import { APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';

import { Injector, NgModule } from '@angular/core';
import { LIB_CONFIG } from '@challenger/care/lib-config';
import { LibConfig } from '@challenger/care/models/lib-config.model';

//const fragmentMatcher = new IntrospectionFragmentMatcher({
// migration note: IntrospectionFragmentMatcher is removed, can be replaced with possibletypes config if needed
// https://apollo-angular.com/docs/data/fragments#defining-possibletypes-manually

@NgModule({
  exports: [],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: (httpLink: HttpLink, injector: Injector) => {
        const config = injector.get<LibConfig>(LIB_CONFIG);
        const uri = config.graphQLURL;
        return {
          link: httpLink.create({ uri }),
          cache: new InMemoryCache(),
        };
      },
      deps: [HttpLink, Injector],
    },
  ],
})
export class GraphQLModule {}
